<template>
        <v-row class="fill-height" align-content="center" justify="center">
            <v-col xs="12" md="6" class="text-center" style="border-right:1px solid #e0e0e0">
                <v-img :src="require('@/assets/images/lfa-logo.png')" aspect-ratio="2"></v-img>
            </v-col>
            <v-col xs="12" md="6" align-self="center">
                <div style="padding:0 35% 0 20px;">
                    <h1 class="font-weight-light grey--text text--darken-3">Admin panel login</h1>
                    <p class="caption grey--text text--darken-2">Click the button below to sign in to the admin panel using your LFA account.</p>

                    <v-alert :value="alertVisible" type="warning">{{ errorMessage }}</v-alert>

                    <div v-show="view == 'login'">
                        <v-text-field v-model="username" label="Email" type="text" :error-messages="usernameError"
                            outline single-line @keydown.enter="login" ref="username" prepend-icon="mdi-account-outline"></v-text-field>
                        <v-text-field v-model="password" label="Password" type="password" :error-messages="passwordError" 
                            outline single-line @keydown.enter="login" ref="password" prepend-icon="mdi-lock"></v-text-field>

                        <v-btn block depressed color="grey darken-4" class="white--text" :loading="loading" @click="login">Sign In</v-btn>
                        <v-btn block depressed color="grey darken-4" class="mt-2 white--text" :loading="loading" @click="loginAuthentik">Sign in with your LFA account</v-btn>
                    </div>

                    <div v-show="view == 'change'">
                        <v-text-field v-model="newPassword" label="New password" type="password" :error-messages="newPasswordError" 
                            outline single-line @keydown.enter="login" ref="password" prepend-icon="mdi-lock"></v-text-field>
                        <v-text-field v-model="confirmNewPassword" label="Confirm new assword" type="password" :error-messages="confirmNewPasswordError" 
                            outline single-line @keydown.enter="login" ref="password" prepend-icon="mdi-lock"></v-text-field>

                        <v-btn block depressed color="grey darken-4" class="white--text" :loading="loading" @click="changeNLogin">Change password & log in</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
</template>

<script>
import { _st } from '@/softech';
import { mapActions, mapGetters } from 'vuex';

export default {
    data: () => ({
        username                : '',
        usernameError           : '',
        password                : '',
        passwordError           : '',
        loading                 : false,
        errorMessage            : '',
        
        newPassword             : '',
        confirmNewPassword      : '',
        newPasswordError        : '',
        confirmNewPasswordError : '',
        token                   : '',

        view                    : 'login',
    }),
    computed: {
        ...mapGetters({
            isLoggedIn  : 'auth/isLoggedIn',
            authState   : 'auth/authState',
        }),
        alertVisible() {
            return !_st.isEmpty( this.errorMessage );
        }
    },
    created() {
        if( this.isLoggedIn )
            this.$router.push('/dashboard');
    },
    mounted() {
        const query = new URLSearchParams( window.location.search );
        const action = query.get("action");
        
        if( action == 'oidc-authorize' ) {
            this.handleSSOCallback();
        }
    },
    methods: {
        ...mapActions({
            adminSignIn         : 'auth/login',
            changePwdAndSignIn  : 'auth/changePasswordLogin',
            generateAuthState   : 'auth/generateAuthState',
            oAuthLogin          : 'auth/oAuthLogin',
        }),
        loginAuthentik() {
            this.loading = true;

            this.generateAuthState();

            // URL del IdP para autorización (reemplaza con tu URL de IdP)
            const clientId = 'DtncX5r5sP2IA5CPObwAlE6woWDQOPobEkvc5xv6'; // poner esto en una variable .env
            const redirectUri = encodeURIComponent(process.env.NODE_ENV === 'production' ? 'https://admin.l5a.com/?action=oidc-authorize' : 'http://localhost:8081/?action=oidc-authorize'); // poner esto es una variable .env
            const state = this.authState; // Para prevenir ataques CSRF
            const authUrl = `https://auth.l5a.com/application/o/authorize/?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}`;

            window.location.href = authUrl;
        },
        async handleSSOCallback() {
            this.loading = true;

            try {
                const query = new URLSearchParams( window.location.search );
                const code = query.get('code');
                const state = query.get('state');
                
                await this.oAuthLogin({ code, state });
            }
            catch( error ) {
                console.log( error );
            }
            finally {
                this.loading = false;
            }
        },
        async login() {
            if( !this.isValid() ) {
                return;
            }

            try {
                this.loading = true;
                let res = await this.adminSignIn({
                    username: this.username,
                    password: this.password
                });

                this.loading = false;
                if( !res.status && res.error ) {
                    this.mxShowMessage( res.message, 'warning' );
                    return false;
                }

                if( !res.status && !res.error ) {
                    this.errorMessage = res.message;
                    this.password = '';
                    return;
                }

                if( !_st.isEmpty( res.nextStep ) ) {
                    this.view = res.nextStep;
                    this.token = res.token;
                }
            }
            catch(error) {
                this.loading = false;
                this.mxShowMessage( 'ERROR: ' + error, 'error' );
            }
        },
        async changeNLogin() {
            if( !this.isChangeValid() ) {
                return;
            }

            try {
                this.loading = true;
                let res = await this.changePwdAndSignIn({
                    username: this.username,
                    password: this.newPassword,
                    token: this.token
                });

                this.loading = false;
                if( !res.status && res.error ) {
                    this.mxShowMessage( res.message, 'warning' );
                    return false;
                }

                if( !res.status && !res.error ) {
                    this.errorMessage = res.message;
                    this.newPassword = '';
                    this.newPasswordError = '';
                    return;
                }
            }
            catch(error) {
                this.loading = false;
                this.mxShowMessage( 'ERROR: ' + error, 'error' );
            }
        },
        isValid() {
            let errorFound = false;
            this.usernameError = this.passwordError = this.errorMessage = '';

            if( _st.isNUE( this.username ) ) {
                errorFound = true;
                this.usernameError = 'required';
            }
            if( _st.isNUE( this.password ) ) {
                errorFound = true;
                this.passwordError = 'required';
            }

            return !errorFound;
        },
        isChangeValid() {
            let errorFound = false;
            this.usernameError = this.passwordError = this.errorMessage = '';

            if( _st.isNUE( this.username ) ) {
                errorFound = true;
                this.usernameError = 'required';
            }
            if( _st.isNUE( this.newPassword ) ) {
                errorFound = true;
                this.newPasswordError = 'required';
            }
            if( _st.isNUE( this.confirmNewPassword ) ) {
                errorFound = true;
                this.confirmNewPasswordError = 'required';
            }
            if( this.newPassword !== this.confirmNewPassword ) {
                errorFound = true;
                this.confirmNewPasswordError = 'must match the new password';
            }

            return !errorFound;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>